"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppLayout = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _SideNav = _interopRequireDefault(require("../../components/layout-components/SideNav"));

var _TopNav = _interopRequireDefault(require("../../components/layout-components/TopNav"));

var _Loading = _interopRequireDefault(require("../../components/shared-components/Loading"));

var _MobileNav = _interopRequireDefault(require("../../components/layout-components/MobileNav"));

var _HeaderNav = _interopRequireDefault(require("../../components/layout-components/HeaderNav"));

var _PageHeader = _interopRequireDefault(require("../../components/layout-components/PageHeader"));

var _Footer = _interopRequireDefault(require("../../components/layout-components/Footer"));

var _appViews = _interopRequireDefault(require("../../views/app-views"));

var _antd = require("antd");

var _NavigationConfig = _interopRequireDefault(require("../../configs/NavigationConfig"));

var _ThemeConstant = require("../../constants/ThemeConstant");

var _utils = _interopRequireDefault(require("../../utils"));

var _reactCssThemeSwitcher = require("react-css-theme-switcher");

var Content = _antd.Layout.Content;
var useBreakpoint = _antd.Grid.useBreakpoint;

var AppLayout = function AppLayout(_ref) {
  var navCollapsed = _ref.navCollapsed,
      navType = _ref.navType,
      location = _ref.location;

  var currentRouteInfo = _utils.default.getRouteInfo(_NavigationConfig.default, location.pathname);

  var screens = _utils.default.getBreakPoint(useBreakpoint());

  var isMobile = !screens.includes('lg');
  var isNavSide = navType === _ThemeConstant.NAV_TYPE_SIDE;
  var isNavTop = navType === _ThemeConstant.NAV_TYPE_TOP;

  var getLayoutGutter = function getLayoutGutter() {
    if (isNavTop || isMobile) {
      return 0;
    }

    return navCollapsed ? _ThemeConstant.SIDE_NAV_COLLAPSED_WIDTH : _ThemeConstant.SIDE_NAV_WIDTH;
  };

  var _useThemeSwitcher = (0, _reactCssThemeSwitcher.useThemeSwitcher)(),
      status = _useThemeSwitcher.status;

  if (status === 'loading') {
    return /*#__PURE__*/_react.default.createElement(_Loading.default, {
      cover: "page"
    });
  }

  return /*#__PURE__*/_react.default.createElement(_antd.Layout, null, /*#__PURE__*/_react.default.createElement(_HeaderNav.default, {
    isMobile: isMobile
  }), isNavTop && !isMobile ? /*#__PURE__*/_react.default.createElement(_TopNav.default, {
    routeInfo: currentRouteInfo
  }) : null, /*#__PURE__*/_react.default.createElement(_antd.Layout, {
    className: "app-container"
  }, isNavSide && !isMobile ? /*#__PURE__*/_react.default.createElement(_SideNav.default, {
    routeInfo: currentRouteInfo
  }) : null, /*#__PURE__*/_react.default.createElement(_antd.Layout, {
    className: "app-layout",
    style: {
      paddingLeft: getLayoutGutter()
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "app-content ".concat(isNavTop ? 'layout-top-nav' : '')
  }, /*#__PURE__*/_react.default.createElement(_PageHeader.default, {
    display: currentRouteInfo === null || currentRouteInfo === void 0 ? void 0 : currentRouteInfo.breadcrumb,
    title: currentRouteInfo === null || currentRouteInfo === void 0 ? void 0 : currentRouteInfo.title
  }), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_appViews.default, null))), /*#__PURE__*/_react.default.createElement(_Footer.default, null))), isMobile && /*#__PURE__*/_react.default.createElement(_MobileNav.default, null));
};

exports.AppLayout = AppLayout;

var mapStateToProps = function mapStateToProps(_ref2) {
  var theme = _ref2.theme;
  var navCollapsed = theme.navCollapsed,
      navType = theme.navType,
      locale = theme.locale;
  return {
    navCollapsed: navCollapsed,
    navType: navType,
    locale: locale
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)( /*#__PURE__*/_react.default.memo(AppLayout));

exports.default = _default;